import React, { useState } from 'react';

import closeLightbox from '@assets/images/close-lightbox.svg';

type SimpleLightBoxTypes = {
  onClick?: () => void;
  open?: boolean;
};

export const SimpleLightBox: React.FC<SimpleLightBoxTypes> = ({ children, ...props }) => {
  const { onClick, open } = props;

  return (
    <div
      className={`
        ${open? 'fixed mx-w-full max-h-full scale-100 opacity-100 p-5 lg:p-10' : 'absolute mx-w-0 max-h-0 scale-0 opacity-0 '}
        flex
        flex-col
        justify-center
        lg:justify-between
        items-center
        top-0
        right-0
        bottom-0
        left-0
        transition
        overflow-hidden
        bg-black
        bg-opacity-75
        z-40
      `}
    >
      <span
        className="
          flex
          p-5
          absolute
          lg:mt-8
          lg:mr-10
          top-0
          right-0
          cursor-pointer
        "
        onClick={onClick}
      >
        <img src={closeLightbox} width="21" height="21" alt="" />
      </span>
      {children}
    </div>
  );
}